import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Card from "react-bootstrap/Card";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { fetchReportsList } from "../../redux/feature/manufacturing_app/commonReportListSlice";
import { useDispatch } from "react-redux";
import { toastFunc } from "../../components/common/util";
import Constants from "../../common/Constants";
import FilterBox from "../../components/common/FilterBox";
import ProdStatusFilterBox from "../../components/common/ProdStatusFilterBox";
import MaterialTraceFilterBox from "../../components/common/MaterialTraceFilterBox";

export const ReportList = (props) => {
  const [rowsdata, setRowsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [downloadProgress, setDownloadProgress] = useState(false);
  const [getSearchParam, setSearchParam] = useState({});
  const [getNewPerPage, setNewPerPage] = useState(Constants.PER_PAGE);

  const resetSearch = (page) => {
    setSearchParam({});
    fetchData(1, true);
  };

  const fetchData = async (page, filterStatus = false) => {
    setLoading(true);
    let param = {};
    param.page = page;
    param.perPage = getNewPerPage;
    param.name = props.name;
    param.method = props.pageURL;
    param.props = props.parameter ? props.parameter : "";
    param.filter = filterStatus ? {} : getSearchParam;
    dispatch(fetchReportsList(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_common.fetch_success"),
          2000,
        );
      }
      setRowsData(
        res?.payload?.items ? res?.payload?.items : res?.payload?.data,
      );
      setTotalRows(res?.payload?.totalCount);
      let statusCounts = res?.payload?.statusCounts;
      statusCounts = statusCounts ? statusCounts : {};
      let tableDataStatus = {
        totalCount: res?.payload?.totalCount,
        statusCounts: statusCounts,
      };
      if (props.handleTableDataStatus) {
        props.handleTableDataStatus(tableDataStatus);
      }
      setLoading(false);
    });
  };

  const searchData = async (searchObj) => {
    // console.log(">> searchObj", searchObj);
    if (!searchObj.download) {
      setLoading(true);
    } else {
      setDownloadProgress(true)
    }

    if (props.searchedParams) {
      props.searchedParams(searchObj);
    }
    let param = {};
    param.page = 1;
    param.perPage = getNewPerPage;
    param.name = props.name;
    param.method = props.pageURL;
    param.download = searchObj.download;
    param.specialReport = searchObj.specialReport;
    param.props = props.parameter ? props.parameter : "";

    if (props.name === Constants.REPORTS.PRODUCTIONSTATUS.name) {
      //productionStatusReports
      param.filter = {
        deptCode: searchObj.deptCode,
        sizeCode: searchObj.sizeCode,
        jobcard: searchObj.jobcard,
        requiredFrom: searchObj.requiredFrom,
        requiredTo: searchObj.requiredTo,
        jobcardStatus: searchObj.getStatus,
        qcStatus: searchObj.qcStatus,

        customer: searchObj.customer,
        plan: searchObj.plan,
        planType: searchObj.planType,
        required_date_from: searchObj.required_date_from,
        required_date_to: searchObj.required_date_to,
        quantityPerJobCard: isNaN(Number(searchObj.quantityPerJobCard))
          ? undefined
          : Number(searchObj.quantityPerJobCard),
      };
    } else if (props.name === Constants.REPORTS.QUALITYCERTIFICATE.name) {
      //qualityCertificate
      param.filter = {
        sizeCode: searchObj.sizeCode,
        jobcard: searchObj.jobcard,
        requiredFrom: searchObj.requiredFrom,
        requiredTo: searchObj.requiredTo,
        qcStatus: searchObj.qcStatus,

        customer: searchObj.customer,
        plan: searchObj.plan,
        planType: searchObj.planType,
        required_date_from: searchObj.required_date_from,
        required_date_to: searchObj.required_date_to,
      };
    } else if (props.name === Constants.REPORTS.CONSUMPTIONQTYREPORT.name) {
      //consumptionQuantityReports
      param.filter = {
        sizeCode: searchObj.sizeCode,
        jobcard: searchObj.jobcard,
        deptCode: searchObj.deptCode,
        machineCode: searchObj.machineCode,
        consumptionType: searchObj.consumptionType,
        requiredFrom: searchObj.requiredFrom,
        requiredTo: searchObj.requiredTo,
      };
    } else if (props.name === Constants.REPORTS.CHEMICALBATCHREPORTS.name) {
      //chemicalBatchReports
      param.filter = {
        sizeCode: searchObj.sizeCode,
        jobcard: searchObj.jobcard,
        requiredFrom: searchObj.requiredFrom,
        requiredTo: searchObj.requiredTo,
        chemicalBatchNo: isNaN(Number(searchObj.chemicalBatchNo))
          ? undefined
          : Number(searchObj.chemicalBatchNo),
      };
    } else if (props.name === Constants.REPORTS.MATERIALTRACEREPORT.name) {
      //materialTraceReport
      param.filter = {
        rangeFrom: searchObj.rangeFrom,
        rangeTo: searchObj.rangeTo,
        materialTraceNumber: searchObj.materialTraceNumber,
      };
    } else {
      //else part for common
      param.filter = {
        requiredFrom: searchObj.requiredFrom,
        requiredTo: searchObj.requiredTo,
        deptCode: searchObj.deptCode,
        sizeCode: searchObj.sizeCode,
        jobcard: searchObj.jobcard,
        operatorUserId: searchObj.operatorUserId,
        jobcardStatus: searchObj.getStatus,
        chemicalBatchNo: isNaN(Number(searchObj.chemicalBatchNo))
          ? undefined
          : Number(searchObj.chemicalBatchNo),
        qcStatus: searchObj.qcStatus,
        customer: searchObj.customer,
        plan: searchObj.plan,
        planType: searchObj.planType,
        required_date_from: searchObj.required_date_from,
        required_date_to: searchObj.required_date_to,
        quantityPerJobCard: isNaN(Number(searchObj.quantityPerJobCard))
          ? undefined
          : Number(searchObj.quantityPerJobCard),
        delayedBy: isNaN(Number(searchObj.delayedBy))
          ? undefined
          : Number(searchObj.delayedBy),
      };
    }

    setSearchParam(param.filter);
    dispatch(fetchReportsList(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_common.fetch_success"),
          2000,
        );
      }
      if (!searchObj.download) {
        setRowsData(res?.payload?.items);
        let statusCounts = res?.payload?.statusCounts;
        statusCounts = statusCounts ? statusCounts : {};
        let tableDataStatus = {
          totalCount: res?.payload?.totalCount,
          statusCounts: statusCounts,
        };
        if (props.handleTableDataStatus) {
          props.handleTableDataStatus(tableDataStatus);
        }
        setTotalRows(res?.payload?.totalCount);
        setLoading(false);
      } else {
       setTimeout(() => {
            setDownloadProgress(false);
        }, 1000);
      }
    });
  };

  const handlePageChange = (page) => {
    fetchData(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    let param = {};
    param.page = page;
    param.perPage = newPerPage;
    param.name = props.name;
    param.method = props.pageURL;
    param.props = props.parameter ? props.parameter : "";
    param.filter = Object.keys(getSearchParam).length > 0 ? getSearchParam : {};

    setNewPerPage(newPerPage);
    dispatch(fetchReportsList(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_common.fetch_success"),
          2000,
        );
      }
      setRowsData(res?.payload?.items);
      let statusCounts = res?.payload?.statusCounts;
      statusCounts = statusCounts ? statusCounts : {};
      let tableDataStatus = {
        totalCount: res?.payload?.totalCount,
        statusCounts: statusCounts,
      };
      if (props.handleTableDataStatus) {
        props.handleTableDataStatus(tableDataStatus);
      }
      setTotalRows(res?.payload?.totalCount);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData(1); // fetch page 1 of users

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.reloadFlag === true) {
      fetchData(1); // your existing data loading logic
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reloadFlag]);

  return (
    <>
      {props.displayFilter && (
        <Row className="reportheader">
          <Col xs={12} md={12} className="leftSide">
            <FilterBox
              operatorFilter={props.operatorFilter}
              searchData={searchData}
              handleDownload={searchData}
              resetFilerBox={props.resetFilerBox}
              resetSearch={resetSearch}
              downloadProgress={downloadProgress}
            ></FilterBox>
          </Col>
        </Row>
      )}
      {props.displayMaterialTraceFilter && (
        <Row className="reportheader">
          <Col xs={12} md={12} className="leftSide">
            <MaterialTraceFilterBox
              operatorFilter={props.operatorFilter}
              searchData={searchData}
              handleDownload={searchData}
              resetFilerBox={props.resetFilerBox}
              resetSearch={resetSearch}
              downloadProgress={downloadProgress}
            ></MaterialTraceFilterBox>
          </Col>
        </Row>
      )}
      {props.displayProdStatusFilter && (
        <Row className="reportheader">
          <Col xs={12} md={12} className="leftSide">
            <ProdStatusFilterBox
              searchData={searchData}
              deptOptionReq={props.deptOptionReq === false ? false : true}
              jobcardStatusReq={props.jobcardStatusReq === false ? false : true}
              customer={props.customer === false ? false : true}
              required_date={props.required_date === false ? false : true}
              plan={props.plan === false ? false : true}
              planType={props.planType === false ? false : true}
              CompletedDate={props.CompletedDate === false ? false : true}
              handleDownload={searchData}
              resetFilerBox={props.resetFilerBox}
              resetSearch={resetSearch}
              downloadProgress={downloadProgress}
              pageName={props.pageName}
            ></ProdStatusFilterBox>
          </Col>
        </Row>
      )}
      <Card>
        <Card.Body>
          <DataTable
            // title={props.pageName}
            selectableRowDisabled={props.enableRowSelection}
            selectableRows={props.selectableRows ? true : false}
            columns={props.columnsData}
            data={rowsdata}
            progressPending={loading}
            paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            handleSelections
            onSelectedRowsChange={props.handleSelections}
            clearSelectedRows={props.clearSelectedRows}
          />
        </Card.Body>
      </Card>
    </>
  );
};
ReportList.defaultProps = {
  cardHeader: true,
};
export default ReportList;
